import list from './list';
import create from './create';
import icon from '@mui/icons-material/Redeem';

/**
 * Sin `edit` ni `show`: un bono cerrado es inmutable y renovar es crear uno nuevo. La ausencia es
 * la regla de negocio, no una funcionalidad pendiente.
 */
const adminConfig = { list, create, icon };

export default adminConfig;
